import { useEffect } from 'react';

type Seo = {
  metaTitle?: string;
  metaDescription?: string;
  keywords?: string[];
};

export function useBrandPageSeo(brandName: string, seo?: Seo, slug?: string) {
  useEffect(() => {
    const title = seo?.metaTitle?.trim() || `${brandName} — Shop at NLS Store`;
    document.title = title;

    const setMeta = (name: string, content: string, attr: 'name' | 'property' = 'name') => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', seo?.metaDescription || `Shop ${brandName} products at NLS Store.`);
    if (seo?.keywords?.length) {
      setMeta('keywords', seo.keywords.join(', '));
    }
    setMeta('og:title', title, 'property');
    setMeta('og:description', seo?.metaDescription || '', 'property');
    if (slug) {
      setMeta('og:url', `${window.location.origin}/brands/${slug}`, 'property');
    }

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Brand',
      name: brandName,
      url: slug ? `${window.location.origin}/brands/${slug}` : undefined,
    };
    let script = document.getElementById('brand-page-schema') as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = 'brand-page-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      document.getElementById('brand-page-schema')?.remove();
    };
  }, [brandName, seo?.metaTitle, seo?.metaDescription, seo?.keywords, slug]);
}
